<template>
  <div class = "SiteSelect">
    <div class="PageHeader">
      <h2 class="PageHeader__subheading">{{$t("gsRideSelectHeading")}}</h2>
      <div class="Selection">
        <button v-for="site in filteredSites" :key="site.id" class="Selection__item" v-on:click="selectSite(site)"><span>{{ site.name }}</span></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GSSiteSelect',
  data: function() {
    return {
      parent: this.$parent,
      filteredSites: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$parent.state.product === undefined) {
        console.log('No product selected.  Redirecting to guest services product select')
        this.$router.push('/guest-services/productSelect')
      }
      let state = this.$parent.getState()
      if (state.product.filter_sites === 'TRUE') {
        this.filteredSites = this.filterSites();
        if (this.filteredSites.length === 1) {
          this.$parent.state.site = this.filteredSites[0].id;
          this.$router.replace('/guest-services/faq');
        }
      } else {
        this.$router.replace('/guest-services/faq');
      }
    })
  },
  methods: {
    filterSites() {
      let state = this.$parent.getState();
      let productId = state.product.id;
      let regionId = state.region.id;
      return this.$parent.config.Sites.filter((site) => {
        return site.products.includes(productId) && site.region === regionId;
      })
    },
    selectSite(site) {
      this.parent.state.site = site.id;
      this.$router.push({
        path: '/guest-services/faq'
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/GuestServices/GSSiteSelect.vue